export default __webpack_public_path__ + "static/LittlePrinceRose-2d96bce35b2b7dbf9f41be498af843b9.png";